<template>
    <div class="body">
        <div class="top-box-top">
            <top />
        </div>
        <div class="bottom-box">
            <basecom />
            <div class="list">
                <div class="medical-list">
                    <funclist
                    style="width: 100%"
                    :row-class-name="tableRowClassName"
                    :header-cell-style="{ 
                    background:'#000',color:'#fff'}"
                    :tableData="this.funlogic.loadFunList()"
                    :tableHeader="this.funlogic.listHeader()"
                    :lazyLoad="this.funlogic.getChildFunList"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import basecom from "@/components/base";
import top from "@/components/top";
import funclist from "@/components/listComponents/treeList";
export default {
    components: {
    basecom,
    funclist,
    top
},
data() {
    return {
    };
},
mounted() {
},
methods: {
    tableRowClassName({row, rowIndex}) {
        if(rowIndex%2==1){
            return 'warning-row';
        }else{
            return 'success-row';
        }
    },
},
};
</script>